import { createStyles, Theme } from '@material-ui/core/styles';
import { Manrope } from '../../constants/theme';

/**
 *
 * @param {Theme} theme Material Theam.
 * @returns {Theme} Return Material theams.
 */
const Styles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			justifyContent: 'space-around',
			marginTop: '4%'
		},
		rootBackground: {
			display: 'flex',
			flexDirection: 'column'
		},
		logo: {
			width: '168px',
			alignSelf: 'center'
		},
		pageContainer: {
			borderRadius: 4,
			boxShadow:
				'3px 3px 6px 3px rgb(0 0 0 / 5%), 0px 0px 0px 0px rgb(0 0 0 / 5%), 0px 0px 6px 0px rgb(0 0 0 / 5%)', //theme.shadows[1],
			display: 'flex',
			flexDirection: 'column',
			background: 'white',
			width: '360px',
			minHeight: '240px',
			paddingBottom: '16px',
			marginTop: '24px',
			[theme.breakpoints.down('sm')]: {
				width: '320px',
				minHeight: '240px',
				marginRight: '0px',
				marginTop: '24px'
			}
		},
		locklogoContainer: {
			width: '34px',
			height: '34px',
			alignSelf: 'center',
			marginTop: '16px',
			background: '#046D39',
			padding: '6px',
			borderRadius: '50%'
		},
		formRoot: {
			flexGrow: 1,
			display: 'flex',
			flexDirection: 'column',
			paddingTop: theme.spacing(1)
		},
		title: {
			fontFamily: Manrope,
			color: '#2E2C34',
			fontSize: '12px',
			fontWeight: 600,
			textAlign: 'left',
			marginTop: theme.spacing(0.5),
			marginLeft: theme.spacing(3),
			marginRight: theme.spacing(3),
			[theme.breakpoints.down('sm')]: {
				marginLeft: theme.spacing(2),
				marginRight: theme.spacing(2)
			}
		},
		titleDescription: {
			fontFamily: Manrope,
			color: '#2E2C34',
			fontSize: '12px',
			fontWeight: 500,
			textAlign: 'center',
			marginTop: theme.spacing(0.5),
			marginLeft: theme.spacing(3),
			marginRight: theme.spacing(3),
			[theme.breakpoints.down('sm')]: {
				marginLeft: theme.spacing(2),
				marginRight: theme.spacing(2)
			}
		},
		titleDescriptionSuccess: {
			fontFamily: Manrope,
			color: '#2E2C34',
			fontSize: '14px',
			fontWeight: 560,
			textAlign: 'center',
			marginTop: theme.spacing(0.5),
			marginLeft: theme.spacing(3),
			marginRight: theme.spacing(3),
			[theme.breakpoints.down('sm')]: {
				marginLeft: theme.spacing(2),
				marginRight: theme.spacing(2)
			}
		},
		pinBox1: {
			display: 'flex',
			justifyContent: 'center',
			marginTop: theme.spacing(1),
			marginLeft: theme.spacing(3),
			marginRight: theme.spacing(3),
			[theme.breakpoints.down('sm')]: {
				marginLeft: theme.spacing(2),
				marginRight: theme.spacing(2)
			}
		},
		pinBox2: {
			display: 'flex',
			justifyContent: 'center',
			marginBottom: theme.spacing(1),
			marginTop: theme.spacing(1),
			marginLeft: theme.spacing(3),
			marginRight: theme.spacing(3),
			[theme.breakpoints.down('sm')]: {
				marginLeft: theme.spacing(2),
				marginRight: theme.spacing(2)
			}
		},
		actions: {
			marginTop: theme.spacing(2),
			alignItems: 'center',
			display: 'flex',
			justifyContent: 'center',
			marginLeft: theme.spacing(3),
			marginRight: theme.spacing(3),
			[theme.breakpoints.down('sm')]: {
				marginLeft: theme.spacing(2),
				marginRight: theme.spacing(2)
			}
		},
		signIn: {
			'text-transform': 'none !important',
			height: theme.spacing(4.5),
			width: theme.spacing(12)
		},
		errorMessage: {
			fontFamily: Manrope,
			color: '#F44336',
			fontSize: '13px',
			fontWeight: 500,
			textAlign: 'center',
			marginTop: theme.spacing(2)
		},
		errorMessage1: {
			fontFamily: Manrope,
			color: '#F44336',
			fontSize: '13px',
			fontWeight: 500,
			textAlign: 'center',
		}
	});

export default Styles;
